var map = {
	"./calendar-alt-solid.svg": "c985",
	"./city-solid.svg": "d4ee",
	"./dashboard.svg": "f782",
	"./elementor-brands.svg": "210b",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./file-audio-solid.svg": "c3f5",
	"./form.svg": "eb1b",
	"./mask-solid.svg": "2d72",
	"./palette-solid.svg": "fd6b",
	"./password.svg": "2a3d",
	"./tree.svg": "93cd",
	"./youtube-brands.svg": "bba0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";